import { render, staticRenderFns } from "./FormDinamicPQR.vue?vue&type=template&id=885301aa"
import script from "./FormDinamicPQR.vue?vue&type=script&lang=js"
export * from "./FormDinamicPQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports